function moveOverlayMobileButtonGroups(scope) {
  const root = scope || document;
  const sections = root.querySelectorAll
    ? root.querySelectorAll('.image-with-text-overlay-blocks')
    : [];

  sections.forEach((section) => {
    const target = section.querySelector('[data-overlay-mobile-groups]');
    if (!target) return;

    const groups = section.querySelectorAll('[data-overlay-mobile-group]');
    if (!groups.length) {
      target.hidden = true;
      return;
    }

    groups.forEach((group) => {
      target.appendChild(group);
    });
    target.hidden = false;
  });
}

function initOverlayMobileButtonGroups(event) {
  const scope = event?.target?.querySelector
    ? event.target
    : document;
  moveOverlayMobileButtonGroups(scope);
}

document.addEventListener('DOMContentLoaded', initOverlayMobileButtonGroups);

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initOverlayMobileButtonGroups);
  document.addEventListener('shopify:block:select', initOverlayMobileButtonGroups);
}
